import React from "react";
import * as Select from "@radix-ui/react-select";
import {
  AHIcon,
  AHText,
  AHTextFonts,
  Box,
  TextTypes,
  useLayoutContext,
  useSpaceSize,
  useTheme,
} from "arkh";

import styles from "./Selector.module.css";

export function SelectorContent(props: { children?: React.ReactNode }) {
  const theme = useTheme();
  const layout = useLayoutContext();
  return (
    <Select.Content
      className={styles.SelectContent}
      position="popper"
      align="start"
      side="top"
      style={{
        cursor: "pointer",
        overflow: "hidden",
        backgroundColor: theme["surface-primary"],
        borderRadius: layout.radius.medium,
        paddingTop: layout.space.small,
        paddingBottom: layout.space.small,

        zIndex: 99999,
        boxShadow:
          "0px 10px 38px -10px rgba(22, 23, 24, 0.35), 0px 10px 20px -15px rgba(22, 23, 24, 0.2)",
      }}
    >
      <Select.ScrollUpButton />
      <Select.Viewport>
        {props.children}
        <Select.Separator />
      </Select.Viewport>
      <Select.ScrollDownButton />
      <Select.Arrow fill="#FFF" />
    </Select.Content>
  );
}

export function SelectorValueTrigger(props: {
  valueLabel: string;
  textType?: TextTypes;
  mode: "compact" | "large";
}) {
  const layout = useLayoutContext();
  const theme = useTheme();
  const f = useSpaceSize("small");
  return (
    <Select.Trigger
      className={styles.Trigger}
      style={{
        cursor: "pointer",
        border: "none",

        display: "flex",
        boxSizing: "border-box",
        alignItems: "center",
        paddingLeft: f,
        marginLeft: -f,
        paddingRight: f,
        marginRight: -f,
        justifyContent: "space-between",
        borderRadius:
          props.mode === "compact" ? layout.radius.medium : layout.radius.large,
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: theme["border-primary"],
        lineHeight: 1,
        height: props.mode === "compact" ? 40 : 52,
      }}
    >
      <Box
        style={{
          overflow: "hidden",
          flex: 1,
        }}
      >
        <Select.Value>
          <Box
            style={{
              width: "100%",
              overflow: "hidden",
            }}
          >
            <AHText
              spaceRight="small"
              spaceLeft={props.mode === "compact" ? "none" : "small"}
              type={props.textType ?? "subtitle"}
              font={AHTextFonts.BOLDER}
              ellipsizeMode="tail"
              color="text-primary"
              numberOfLines={1}
            >
              {props.valueLabel}
            </AHText>
          </Box>
        </Select.Value>
      </Box>
      <AHIcon
        type="chevron-down"
        color="text-secondary"
        spaceRight={props.mode === "compact" ? "none" : "small"}
      />
    </Select.Trigger>
  );
}

export function SelectorListItem(props: {
  data: {
    id: string;
    name: string;
  };
  selectedId: string | undefined;
}) {
  const horizontal = useSpaceSize("small");
  return (
    <Box spaceHorizontal="small">
      <Select.Item
        value={props.data.id}
        className={styles.SelectItem}
        style={{
          fontSize: 13,
          lineHeight: 1,
          borderRadius: 10,
          display: "flex",
          alignItems: "center",
          height: 40,
          paddingLeft: horizontal,
          paddingRight: horizontal,
          position: "relative",
          userSelect: "none",
        }}
      >
        <Box style={{ flex: 1 }}>
          <Box
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              flex: 1,
            }}
          >
            <Select.ItemText>
              <AHText type="subtitle" color="darkerText" spaceRight="large">
                {props.data.name}
              </AHText>
            </Select.ItemText>
          </Box>
        </Box>
        <Select.ItemIndicator />
        {props.selectedId === props.data.id ? (
          <AHIcon type="check" color="primary" />
        ) : null}
      </Select.Item>
    </Box>
  );
}
